import { DesktopDatePickerProps } from "@mui/lab";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import { FieldValidator, useField } from "formik";

interface Props extends DesktopDatePickerProps<any> {
    name: string;
    label: string;
    helperText?: string;
    onChange?: (value: Date) => void;
    validate?: FieldValidator;
}

const FormTimePicker = ({
    name,
    label,
    helperText,
    onChange,
    validate,
    ...rest
}: Props) => {
    const [field, meta, helpers] = useField({ name, validate });
    return (
        <DesktopTimePicker
            label={label}
            {...rest}
            {...field}
            onChange={(value) => {
                helpers.setValue(value);
                if (onChange) {
                    onChange(value);
                }
            }}
            onError={() => {
                helpers.setError("Please select a better time");
            }}
            slotProps={{
                textField: {
                    error: meta.error ? true : false,
                    helperText: meta.error || helperText,
                    variant: "standard",
                },
            }}
        />
    );
};

export default FormTimePicker;
